module.exports = __webpack_public_path__ + "img/thumb_19.c64d955e.jpg";